class MenuItemCardV2 extends React.Component {
    constructor(props) {
        super(props);
        this.sendComboUrlData = this.sendComboUrlData.bind(this);
        this.state = { allComboData: null, loading: false }
    }
    componentDidMount() {
    }
    sendComboUrlData(e) {
        this.props.sendIsComboPage()
    }
    render() {
        var isAlcohol = this.props.isAlcohol;
        var isQuickAdd;
        var isMenuAvailable = true;
        
        if (!this.props.isOnline || !this.props.menuItemAvailable) {
            isMenuAvailable = false;
        }
        
        isQuickAdd = this.props.isQuickAdd;
        const { menuItemUrl, menuItemImage, menuItemTitle, menuItemCalories, menuItemPrice, isFeaturedMenu, menuItemCalcPrice } = this.props;

        return (
            <a href={this.props.menuItemUrl} onClick={(!isMenuAvailable || isQuickAdd) ? (event) => console.log(event) : this.sendComboUrlData} className={isAlcohol ? "listing-card-item subcategoryMenuCard js-alcohol-see-details" : "listing-card-item subcategoryMenuCard" 
    }>
                <div className="cardMenu-box subcategory-box">
                    <div className="row item-center">
                        <div className="featureWrapper">
                            <img src={menuItemImage} alt="product image" class="img-fluid" />
                            {isFeaturedMenu == true ? <div className="featureItem default-text" tabIndex="0">Featured Item</div> : " "}
                        </div>
                        <div className="subcategory-description-wrapper p-0">
                        <div className="subcategory-description">
                            <h4 className="mcl-title text-truncate" aria-label={menuItemTitle} tabIndex="0">{menuItemTitle}</h4>
                            {(typeof this.props.menuItemLabels !== 'undefined') ? (
                                this.props.menuItemLabels.filter(labels => (labels.Code.toLowerCase() == "nychighsodium" || labels.Code.toLowerCase() == "phlsodiumwarning")).map(filteredLabel => (
                                    <img src={filteredLabel.Image} alt={filteredLabel.Name} data-code={filteredLabel.Code.toLowerCase()}
                                        className={filteredLabel.Code.toLowerCase()} />
                                ))
                            ) : null}
                            {(menuItemCalcPrice != 0 && menuItemCalories != "") ?
                                <p className="p1 bold itemPrice" tabindex="0">{menuItemPrice}<span className="calories">{menuItemCalories} Cal </span></p> :
                                (menuItemCalcPrice != 0 && menuItemCalories == "") ?
                                    <p className="p1 bold itemPrice" tabindex="0">{menuItemPrice}</p> :
                                    (menuItemCalcPrice == 0 && menuItemCalories != "") ?
                                        <p className="p1 bold itemPrice" tabindex="0"><span>{menuItemCalories} Cal </span></p> :
                                        ""
                            }
                        </div>
                        <div className="buttonFooter">
                            {isQuickAdd && this.props.isOnline ? <a href={this.props.menuItemUrl} type="button" className={isAlcohol ? "btn btn-primary btn-md btn-md--no-icon m-r-10 js-alcohol-add-to-bag" : "btn btn-primary btn-md btn-md--no-icon m-r-10 js-quick-add-to-bag"} data-productid={this.props.menuItemProductId} data-chainproductid={this.props.menuItemChainProductId}>{this.props.menuCardData.AddToBagButtonText}</a> : ""}
                            {isQuickAdd ? <a href={this.props.menuItemUrl} type="button" className={isAlcohol ? "btn btn-default btn-md btn-md--no-icon quick-add js-alcohol-see-details" : "btn btn-default btn-md btn-md--no-icon"} data-productid={this.props.menuItemProductId} data-chainproductid={this.props.menuItemChainProductId}>{this.props.menuCardData.SeeDetailsButtonText}</a> : ""}
                        </div>
                        </div>
                    </div>
                </div>
               
            </a>
        );
    }
}

export default MenuItemCardV2;